require('./DashboardModalTaskCollapsibleContent.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    {t} = require('services/i18nextWrapper'),
    {TimePicker} = require('material-ui'),
    TextField = require('components/Commons/TextField/TextField'),
    DashboardModalUtils = require('components/DashboardModal/DashboardModalUtils'),
    _ = require('lodash'),
    DateUtils = require('utils/DateUtils');

const DashboardModalTaskCollapsibleItem = React.createClass({displayName: "DashboardModalTaskCollapsibleItem",

    propTypes: {
        orderProcessHydrated: PropTypes.object,
        uniqueId: PropTypes.string,
        existingTask: PropTypes.object,
        onChangeProcess: PropTypes.func,
        isSingle: PropTypes.bool,
        fromDate: PropTypes.string,
        fromHour: PropTypes.string,
        toDate: PropTypes.string,
        toHour: PropTypes.string
    },

    getInitialState() {
        return {
            total: '',
            note: '',
            noteUpdated: '',
            isDefinedFromDate: false,
            isDefinedToDate: false
        };
    },

    componentWillReceiveProps(nextProps) {
        if (!this.isMounted()) { // avoid several problem of rendering when try to call 'refs' which are not mounted yet
            return;
        }

        const {fromDate, fromHour, toDate, toHour} = nextProps;
        let isDefinedFromDate,
            isDefinedToDate,
            fromDateDefined,
            toDateDefined;


        if (fromDate) {
            fromDateDefined = DateUtils.toDateAndHours(fromDate, fromHour);
            this.refs.fromDate.setTime(fromDateDefined);
            isDefinedFromDate = true;
        }

        if (toDate) {
            toDateDefined = DateUtils.toDateAndHours(toDate, toHour);
            this.refs.toDate.setTime(toDateDefined);
            isDefinedToDate = true;
        }

        if (isDefinedFromDate && isDefinedToDate) {
            this._updateTotalLabel(fromDateDefined, toDateDefined);
            this.setState({
                isDefinedToDate: true,
                isDefinedFromDate: true
            });
        }
    },

    _onChangeNote(evt) {

        const note = evt.target.value || '';

        this.setState({
            note
        });

        this.props.onChangeProcess({
            note,
            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
            existingProcess: _.get(this.props, 'existingTask.process') || [],
            date: _.get(this.props, 'existingTask.date') || DashboardModalUtils.getDateFromTaskId(_.get(this.props, 'existingTask')),
            processSection: _.get(this.props, 'existingTask.sectionType') || _.get(this.props, 'orderProcessHydrated.processSection'),
            taskId: _.get(this.props, 'existingTask.taskId'),
            processId: _.get(this.props, 'orderProcessHydrated.id')
        });
    },

    _onChangeFromDate(context, fromDate) {
        const toDate = this.refs.toDate.getTime();
        const {isDefinedToDate} = this.state;

        if (isDefinedToDate) {
            // enter here means that both dates are already defined
            this._updateTotalLabel(fromDate, toDate);
        }

        const taskDate = _.get(this.props, 'existingTask.date') || DashboardModalUtils.getDateFromTaskId(_.get(this.props, 'existingTask'));

        // this method came from DashboardModalBrewStore.onChangeProcess
        this.props.onChangeProcess({
            existingProcess: _.get(this.props, 'existingTask.process') || [],
            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
            fromDate: taskDate,
            fromHour: DateUtils.toDateTextWithHHMM(fromDate),
            date: taskDate,
            // following field just to identify
            taskId: _.get(this.props, 'existingTask.taskId'),
            processId: _.get(this.props, 'orderProcessHydrated.id'),
            processSection: _.get(this.props, 'existingTask.sectionType') || _.get(this.props, 'orderProcessHydrated.processSection')
        });

        this.setState({isDefinedFromDate: true});
    },

    _onChangeToDate(context, toDate) {
        const fromDate = this.refs.fromDate.getTime();
        const {isDefinedFromDate} = this.state;

        if (isDefinedFromDate) {
            // enter here means that both dates are already defined
            this._updateTotalLabel(fromDate, toDate);
        }

        const taskDate = _.get(this.props, 'existingTask.date') || DashboardModalUtils.getDateFromTaskId(_.get(this.props, 'existingTask'));

        // this method came from DashboardModalBrewStore.onChangeProcess
        this.props.onChangeProcess({
            existingProcess: _.get(this.props, 'existingTask.process') || [],
            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
            toDate: taskDate,
            toHour: DateUtils.toDateTextWithHHMM(toDate),
            date: taskDate,
            // following field just to identify
            taskId: _.get(this.props, 'existingTask.taskId'),
            processId: _.get(this.props, 'orderProcessHydrated.id'),
            processSection: _.get(this.props, 'existingTask.sectionType') || _.get(this.props, 'orderProcessHydrated.processSection')
        });

        this.setState({isDefinedToDate: true});
    },

    _updateTotalLabel(from, to) {
        if (from && to) {
            const minutesDiff = DateUtils.getMinutesBetween(from, to);
            this.setState({total: minutesDiff + ' min'});
        } else {
            this.setState({total: ''});
        }
    },

    _onDeleteProcess() {
        // this method came from DashboardModalBrewStore.onChangeProcess
        this.props.onChangeProcess({
            toDate: null,
            toHour: null,
            fromDate: null,
            fromHour: null,
            note: '',
            isDeletingOperation: true,
            // following field just to identify,
            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
            taskId: _.get(this.props, 'existingTask.taskId'),
            processId: _.get(this.props, 'orderProcessHydrated.id'),
            processSection: _.get(this.props, 'orderProcessHydrated.processSection')
        });

        this.setState({total: ''});
        this.setState({note: ''});

        // TODO: Workaround of material-ui 0.10.0 that not update value of internal input after change it.
        this.refs.fromDate.getDOMNode().querySelector('input').value = '';
        this.refs.toDate.getDOMNode().querySelector('input').value = '';
    },

    isEmpty() {
        const process = _.get(this.props, 'orderProcessHydrated', {});
        return DashboardModalUtils.isEmptyProcess(process);
    },

    render() {
        const {orderProcessHydrated, uniqueId} = this.props;
        const styleInputs = {
            marginTop: '-10px',
            height: '40px',
            lineHeight: '25px',
            width: 'initial'
        };

        return (
            React.createElement("li", {key: uniqueId, className: "dashboard-modal-task-collapsible-content row", style: {
                listStyle: 'none'
            }}, 
                React.createElement("label", {className: "dashboard-modal-task-collapsible-content__label text-left col-xs-offset-1 col-xs-2"}, 
                    orderProcessHydrated.label
                ), 
                React.createElement("div", {className: "dashboard-modal-task-collapsible-content__time col-xs-2"}, 
                    React.createElement(TimePicker, {
                        hintText: t('dashboard_modal_task_qc_start'), 
                        style: styleInputs, 
                        ref: "fromDate", 
                        key: 'fromDate-' + uniqueId, 
                        onChange: this._onChangeFromDate}
                    )
                ), 
                React.createElement("div", {className: "dashboard-modal-task-collapsible-content__time col-xs-2"}, 
                    React.createElement(TimePicker, {
                        hintText: t('dashboard_modal_task_qc_end'), 
                        style: styleInputs, 
                        ref: "toDate", 
                        key: 'toDate-' + uniqueId, 
                        onChange: this._onChangeToDate}
                    )
                ), 
                React.createElement("div", {className: "dashboard-modal-task-collapsible-content__input col-xs-1"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeNote, 
                        floatingLabelText: t('dashboard_modal_task_qc_total'), 
                        value: this.state.total, 
                        disabled: true, 
                        key: 'timeTotal-' + uniqueId}
                    )
                ), 
                React.createElement("div", {className: "dashboard-modal-task-collapsible-content__note col-xs-3"}, 
                    React.createElement(TextField, {
                        onBlur: this._onChangeNote, 
                        floatingLabelText: t('dashboard_modal_task_qc_note'), 
                        value: this.state.note || _.get(orderProcessHydrated, 'note', ''), 
                        key: 'timeNote-' + uniqueId}
                    ), 

                    React.createElement("i", {title: t('dashboard_modal_task_delete_process'), 
                       style: {
                           display: this.isEmpty() ? 'none' : 'initial'
                       }, 
                       className: "material-icons md-16 ", 
                       onClick: this._onDeleteProcess}, "delete")
                )
            )
        );
    }
});

module.exports = DashboardModalTaskCollapsibleItem;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsibleItem.jsx
 **/